import { render, staticRenderFns } from "./AssignBuyer.vue?vue&type=template&id=65fd5ae9&"
import script from "./AssignBuyer.vue?vue&type=script&lang=js&"
export * from "./AssignBuyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports